/**
 * Does this brand show the "View product page" link (and the platform chip)?
 *
 * OPT-IN: only an explicit `true` turns it on. A brand with no value — every
 * brand that predates the field and has not been saved since — is OFF, exactly
 * as a stored `false` is.
 *
 * That is the rule the RN app applies (watchlock #1104), and the admin has to
 * agree with it. It used to read a missing value as on (`!== false`), so an
 * older brand looked enabled in the editor while showing nothing in the app —
 * and saving that form then wrote the `true` nobody had chosen.
 *
 * Every surface that turns the stored value into a checkbox goes through here,
 * so the rule has one definition.
 */
export function brandShowsProductLinks(showProductLinks: unknown): boolean {
  return showProductLinks === true;
}
